export function useAddressApi() {
  const { errors, request } = useRequest();

  async function CreateAssociatedAddress(requestBody: CreateAssociatedAddressRequestDTO) {
    const url = versionedUrl('Address/CreateAssociatedAddress');

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<CreateAssociatedAddressResponseDTO>(url, requestOptions);
  }

  async function GetCountries() {
    const url = versionedUrl('Address/GetCountries');

    return await request<string[]>(url);
  }

  async function SearchAddress(requestBody: SearchAddressRequestDTO) {
    const url = versionedUrl('Address/SearchAddress');

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody };

    return await request<AddressSuggestion[]>(url, requestOptions);
  }

  async function GetCoordinates(requestBody: AddressCoordinatesRequestDTO) {
    const url = versionedUrl('Address/GetCoordinates');

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddressCoordinates[]>(url, requestOptions);
  }

  return {
    errors,
    GetCoordinates,
    SearchAddress,
    GetCountries,
    CreateAssociatedAddress
  };
}
